import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography,
  Spinner
} from '@material-tailwind/react'
import CustomSelect from '../../custom-select'
import { FileInput } from '../../file-input'
import { FiZap } from 'react-icons/fi'
import { useState, useMemo, useEffect } from 'react'
import { importServices } from '@/services'
import { NotificationModal } from '@/components/notification-modal'
import { store } from '@/store'
import { assetV2Api } from '@/store/services'

export const DataUploadModal = (props) => {
  const [selectedModule, setSelectedModule] = useState(null)
  const [uploadedFile, setUploadedFile] = useState([])
  const [assetCategories, setAssetCategories] = useState([])
  const [assetTypes, setAssetTypes] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedType, setSelectedType] = useState(null)
  const [showNotificationModal, setShowNotificationModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [iconTypeNotificacionModal, setIconTypeNotificacionModal] = useState('')
  const [titleNotificacionModal, setTitleNotificationModal] = useState('')
  const [messageNotificacionModal, setMessageNotificationModal] = useState('')

  const moduleOptions = useMemo(() => {
    return [
      { value: 'contractors', label: 'Contratistas' },
      { value: 'contracts', label: 'Contratos' },
      { value: 'employees', label: 'Personas' },
      { value: 'assets', label: 'Activos' },
      { value: 'assets_v2', label: 'Activos 2.0' }
    ]
  }, [])

  const exportCsvInfo = (errors) => {
    const fileData = errors.join('\n')
    const blob = new Blob([fileData], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.download = `resultado_importacion_${selectedModule?.label?.toLowerCase()}.csv`
    link.href = url
    link.click()
  }

  const validateImportResponse = (response) => {
    const errors = response?.data?.errors
    const csvSize = response?.data?.csv_size
    exportCsvInfo(errors)

    if (errors.length === 0) {
      setIconTypeNotificacionModal('check')
      setTitleNotificationModal('Importación realizada exitosamente.')
      setMessageNotificationModal(
        `Se importaron correctamente todos los datos de ${selectedModule?.label}`
      )
    } else if (errors?.length < csvSize) {
      setIconTypeNotificacionModal('danger')
      setTitleNotificationModal('Importación realizada parcialmente.')
      setMessageNotificationModal(
        'Se importaron correctamente algunos datos de Contratistas. Se descargará automáticamente un archivo con el detalle.'
      )
    } else if (errors?.length === csvSize) {
      setIconTypeNotificacionModal('error')
      setTitleNotificationModal('No se pudieron importar los datos.')
      setMessageNotificationModal(
        'No se pudieron importar los datos del archivo cargado. Verifica que el formato del archivo sea correcto y que los campos obligatorios se estén cumpliendo.'
      )
    }
    setIsLoading(false)
    setShowNotificationModal(true)
  }

  useEffect(() => {
    if (selectedModule?.value === 'assets_v2') {
      store.dispatch(
        assetV2Api.endpoints.getAssetCategories.initiate()
      ).unwrap().then(({ asset_categories: categories = [] }) => {
        const opts = categories.map((c) => ({ value: c.id, label: c.name }))
        setAssetCategories(opts)
      }).catch((err) => console.error('Error fetching asset categories', err))
    } else {
      setAssetCategories([])
      setAssetTypes([])
      setSelectedCategory(null)
      setSelectedType(null)
    }
  }, [selectedModule])

  useEffect(() => {
    if (selectedModule?.value === 'assets_v2' && selectedCategory?.value) {
      store.dispatch(
        assetV2Api.endpoints.getAssetTypes.initiate(selectedCategory.value)
      ).unwrap().then(({ asset_types: types = [] }) => {
        const opts = types.map((t) => ({ value: t.id, label: t.name }))
        setAssetTypes(opts)
      }).catch((err) => console.error('Error fetching asset types', err))
    } else {
      setAssetTypes([])
      setSelectedType(null)
    }
  }, [selectedModule, selectedCategory])

  const uploadFile = () => {
    if (!selectedModule) return

    if (selectedModule.value === 'assets_v2' && !selectedType?.value) {
      setIconTypeNotificacionModal('error')
      setTitleNotificationModal('Falta seleccionar tipo de activo')
      setMessageNotificationModal('Debes elegir categoría y tipo para descargar la plantilla y subir el archivo.')
      setShowNotificationModal(true)
      return
    }

    setIsLoading(true)
    importServices
      .sendFile({
        body: {
          file: uploadedFile,
          asset_type_id: selectedModule.value === 'assets_v2' ? selectedType?.value : undefined
        },
        type: selectedModule.value
      })
      .then((response) => {
        validateImportResponse(response)
        console.log(response.data)
      })
  }

  return showNotificationModal ? (
    <NotificationModal
      title={titleNotificacionModal}
      message={messageNotificacionModal}
      iconType={iconTypeNotificacionModal}
      setBackStateFunction={setShowNotificationModal}
    ></NotificationModal>
  ) : (
    <Dialog {...props}>
      <DialogHeader className='flex flex-col items-start'>
        <div className='flex justify-center items-center w-14 h-14 bg-blue-50 border-blue-50 p-3 rounded-[28px] text-blue-900 mb-4'>
          <div className='flex items-center justify-center bg-blue-100 rounded-[28px] p-3 w-10 h-10'>
            <FiZap size='2rem' className='text-blue-600' />
          </div>
        </div>
        <Typography variant='h5' className='text-black'>
          Módulo de importación masiva
        </Typography>
        <Typography variant='small' className='text-gray-500'>
          En este modal puedes cargar masivamente datos a los módulos de
          Contratos, Contratistas, Personas y Activos.
        </Typography>
      </DialogHeader>
      {isLoading ? (
        <div className='p-10'>
          <div className='grid justify-center '>
            <Spinner className='w-20 h-20 m-5' color='blue' />
          </div>
          <div className='grid justify-center'>
            <Typography variant='small' className='text-gray-500'>
              Realizando importación masiva del modulo {selectedModule?.label}.
              No cerrar esta ventana
            </Typography>
          </div>
        </div>
      ) : (
        <div>
          <DialogBody className='flex flex-col gap-4'>
            <div className='flex flex-col'>
              <CustomSelect
                options={moduleOptions}
                value={selectedModule}
                onChange={(option) => setSelectedModule(option)}
                placeholder='Seleccione el módulo'
              />
              {selectedModule?.value === 'assets_v2' && (
                <div className='mt-4 flex flex-col gap-3'>
                  <CustomSelect
                    options={assetCategories}
                    value={selectedCategory}
                    onChange={(option) => {
                      setSelectedCategory(option)
                      setSelectedType(null)
                    }}
                    placeholder='Selecciona una categoría'
                  />
                  <CustomSelect
                    options={assetTypes}
                    value={selectedType}
                    onChange={(option) => setSelectedType(option)}
                    placeholder='Selecciona un tipo'
                    isDisabled={!selectedCategory}
                  />
                  {selectedType?.value && (
                    <Typography variant='small' className='mt-2'>
                      Descarga el{' '}
                      <a
                        className='text-blue-600 underline'
                        href={`/api/v1/imports/assets_v2_template?asset_type_id=${selectedType.value}`}
                        target='_blank'
                        rel='noreferrer'
                      >
                        formato de esta plantilla
                      </a>
                    </Typography>
                  )}
                </div>
              )}
              {selectedModule && selectedModule.value !== 'assets_v2' && (
                <Typography variant='small' className='mt-2'>
                  Descarga el{' '}
                  <a
                    className='text-blue-600 underline'
                    href={`/csv-templates/${selectedModule?.label?.toLowerCase()}_plantilla.csv`}
                  >
                    formato de esta plantilla
                  </a>
                </Typography>
              )}
            </div>
            <FileInput
              value={uploadedFile}
              handleChange={(file) => setUploadedFile(file)}
            />
          </DialogBody>
        </div>
      )}
      <DialogFooter className='flex justify-between'>
        <Button
          variant='outlined'
          color='white'
          onClick={props.handler}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button onClick={uploadFile} disabled={isLoading}>
          Cargar
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
